import { CreditCard } from './credit-card';

export class RegisteredCreditCard {
    paymentCardId: string;
    availableCards: CreditCard[];
    constructor() {
        this.availableCards = new Array<CreditCard>();
    }
}
